import React, { useState } from "react";
import { useFloating, FloatingPortal, autoUpdate } from "@floating-ui/react";

export function FloatingValue({value, children, isVisible}) {
    const {refs, floatingStyles } = useFloating({
        isOpen: isVisible,
        whileElementsMounted: autoUpdate,
    })
    return <>
        {React.cloneElement(children, {ref: refs.setReference})}
        {isVisible && 
            <FloatingPortal>
                <output className="parameter-value-display" style={floatingStyles} ref={refs.setFloating}>{value}</output>
            </FloatingPortal> 
        }
    </>

}